// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import { registerNiiwinControllers } from "@niiwin/core";
registerNiiwinControllers(application);

import AgreementCheckController from "./agreement_check_controller";
import AgreementModalController from "./agreement_modal_controller";
import BasicSelectController from "./basic_select_controller";
import ChatHistoryController from "./chat_history_controller";
import ChatMessageFormController from "./chat_message_form_controller";
import CommentsToggleController from "./comments_toggle_controller";
import ConversationTitleToggleController from "./conversation_title_toggle_controller";
import CopyToClipBoardController from "./copy_to_clipboard_controller";
import CustomizableCollapseController from "./customizable_collapse_controller";
import DatagridController from "./datagrid_controller";
import DiscussionTagsController from "./discussion_tags_controller";
import FileInputController from "./file_input_controller";
import FileOrUrlSwitchController from "./file_or_url_switch_controller";
import ForceSelectController from "./force_select_controller";
import FormsArrayInputController from "./forms/array_input_controller";
import FormsAssignStoryController from "./forms/assign_story_controller";
import FormsChatStorySearchController from "./forms/chat_story_search_controller";
import FormsClearFormController from "./forms/clear_form_controller";
import FormsDiscussionFormController from "./forms/discussion_form_controller";
import FormsDraftButtonController from "./forms/draft_button_controller";
import FormsFilterrificRemoteSelectController from "./forms/filterrific_remote_select_controller";
import FormsFiltersController from "./forms/filters_controller";
import FormsSubmitBeforeFollowController from "./forms/submit_before_follow_controller";
import GoogleDriveController from "./google_drive_controller";
import LongTouchLinkController from "./long_touch_link_controller";
import NotificationController from "./notification_controller";
import PasswordVisibilityController from "./password_visibility_controller";
import PersistFileChoiceController from "./persist_file_choice_controller";
import PopoverCloseButtonController from "./popover_close_button_controller";
import PopoverController from "./popover_controller";
import OutcomesRemoteSelectController from "./outcomes_remote_select_controller";
import ReadMoreController from "./read_more_controller";
import ReadReceiptController from "./read_receipt_controller";
import RelativeTimeController from "./relative_time_controller";
import RemoteModalController from "./remote_modal_controller";
import RemoteSelectController from "./remote_select_controller";
import ScrollIntoViewController from "./scroll_into_view_controller";
import ScrollSnapController from "./scroll_snap_controller";
import SentryController from "./sentry_controller";
import SidebarController from "./sidebar_controller";
import PositionableController from "./positionable_controller";
import TourguideController from "./tourguide_controller";
import TourguideButtonController from "./tourguide_button_controller";
import TrixAutosaveController from "./trix/autosave_controller";
import TrixEditorController from "./trix/editor_controller";
import TrixMediaRecordingController from "./trix/media_recording_controller";
import TrixMentionsController from "./trix/mentions_controller";
import TrixNewWindowLinkController from "./trix/new_window_link_controller";
import TrixPasteLinkController from "./trix/paste_link_controller";
import TrixSubmitOnEnterController from "./trix/submit_on_enter_controller";
import UserTypeFieldsController from "./user_type_fields_controller";
import VerticalFillController from "./vertical_fill_controller";
import ViewSwitchController from "./view_switch_controller";
import ViewToggleController from "./view_toggle_controller";
import ViewPortResizeController from "./viewport_resize_controller";

application.register("agreement-check", AgreementCheckController);
application.register("agreement-modal", AgreementModalController);
application.register("basic-select", BasicSelectController);
application.register("chat-history", ChatHistoryController);
application.register("chat-message-form", ChatMessageFormController);
application.register("comments-toggle", CommentsToggleController);
application.register("conversation-title-toggle", ConversationTitleToggleController);
application.register("copy-to-clipboard", CopyToClipBoardController);
application.register("customizable-collapse", CustomizableCollapseController);
application.register("datagrid", DatagridController);
application.register("discussion-tags", DiscussionTagsController);
application.register("file-input", FileInputController);
application.register("file-or-url-switch", FileOrUrlSwitchController);
application.register("force-select", ForceSelectController);
application.register("forms--array-input", FormsArrayInputController);
application.register("forms--assign-story", FormsAssignStoryController);
application.register("forms--chat-story-search", FormsChatStorySearchController);
application.register("forms--clear-form", FormsClearFormController);
application.register("forms--discussion-form", FormsDiscussionFormController);
application.register("forms--draft-button", FormsDraftButtonController);
application.register("forms--filterrific-remote-select", FormsFilterrificRemoteSelectController);
application.register("forms--filters", FormsFiltersController);
application.register("forms--submit-before-follow", FormsSubmitBeforeFollowController);
application.register("google-drive", GoogleDriveController);
application.register("long-touch-link", LongTouchLinkController);
application.register("notification", NotificationController);
application.register("password-visibility", PasswordVisibilityController);
application.register("persist-file-choice", PersistFileChoiceController);
application.register("popover-close-button", PopoverCloseButtonController);
application.register("popover", PopoverController);
application.register("outcomes-remote-select", OutcomesRemoteSelectController);
application.register("read-more", ReadMoreController);
application.register("read-receipt", ReadReceiptController);
application.register("relative-time", RelativeTimeController);
application.register("remote-modal", RemoteModalController);
application.register("remote-select", RemoteSelectController);
application.register("scroll-snap", ScrollSnapController);
application.register("scroll-into-view", ScrollIntoViewController);
application.register("sentry", SentryController);
application.register("sidebar", SidebarController);
application.register("positionable", PositionableController);
application.register("tourguide", TourguideController);
application.register("tourguide-button", TourguideButtonController);
application.register("trix--autosave", TrixAutosaveController);
application.register("trix--editor", TrixEditorController);
application.register("trix--media-recording", TrixMediaRecordingController);
application.register("trix--mentions", TrixMentionsController);
application.register("trix--new-window-link", TrixNewWindowLinkController);
application.register("trix--paste-link", TrixPasteLinkController);
application.register("trix--submit-on-enter", TrixSubmitOnEnterController);
application.register("user-type-fields", UserTypeFieldsController);
application.register("vertical-fill", VerticalFillController);
application.register("view-switch", ViewSwitchController);
application.register("view-toggle", ViewToggleController);
application.register("viewport-resize", ViewPortResizeController);
